module.exports = __webpack_public_path__ + "static/logo-8697397a0d6729c79ec822f5667ccb21.png";